export const searchTextAutoCompleteDescription = "PrliQd";
export default {searchTextAutoCompleteDescription};